import {
  faAlignLeft,
  faAward,
  faBullhorn,
  faCamera,
  faCircleInfo,
  faComments,
  faEnvelope,
  faFileLines,
  faGavel,
  faHeading,
  faImage,
  faLandmark,
  faNewspaper,
  faQuestionCircle,
  faTableCells,
  faTableColumns,
  faUsers,
  faVideo,
} from '@awesome.me/kit-4a6bf60416/icons/classic/regular';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface SectionTypeConfig {
  label: string;
  icon: IconDefinition;
}

// Insertion order controls display order in the Add Section modal sidebar.
const TEMPLATE_SECTION_TYPES = new Map<string, SectionTypeConfig>([
  ['hero', { label: 'Intro', icon: faImage }],
  ['about', { label: 'About', icon: faCircleInfo }],
  ['profile_widget', { label: 'Team', icon: faUsers }],
  ['practice_area_widget', { label: 'Practice Areas', icon: faLandmark }],
  ['faq_widget', { label: 'FAQs', icon: faQuestionCircle }],
  ['badges', { label: 'Badges', icon: faAward }],
  ['review_widget', { label: 'Reviews', icon: faComments }],
  ['case_result_widget', { label: 'Case Results', icon: faGavel }],
  ['blog_widget', { label: 'Blog Posts', icon: faNewspaper }],
  ['contact', { label: 'Contact', icon: faEnvelope }],
  ['banner', { label: 'Banner', icon: faBullhorn }],
  ['page_title', { label: 'Page Title', icon: faHeading }],
]);

const BASIC_SECTION_TYPES = new Map<string, SectionTypeConfig>([
  ['text', { label: 'Text', icon: faAlignLeft }],
  ['image', { label: 'Image', icon: faCamera }],
  ['video', { label: 'Video', icon: faVideo }],
  ['slideshow', { label: 'Slideshow', icon: faTableColumns }],
  ['grid', { label: 'Grid', icon: faTableCells }],
]);

const ALL_SECTION_TYPES = new Map<string, SectionTypeConfig>([
  ...TEMPLATE_SECTION_TYPES,
  ...BASIC_SECTION_TYPES,
]);

export const SECTION_TYPE_GROUPS: Array<{ label: string; types: Map<string, SectionTypeConfig> }> =
  [
    { label: 'Templates', types: TEMPLATE_SECTION_TYPES },
    { label: 'Basics', types: BASIC_SECTION_TYPES },
  ];

export function getSectionTypeIcon(sectionType: string): IconDefinition {
  return ALL_SECTION_TYPES.get(sectionType)?.icon ?? faFileLines;
}

export function getSectionTypeLabel(sectionType: string): string {
  return ALL_SECTION_TYPES.get(sectionType)?.label ?? sectionType.replace(/_/g, ' ');
}

export function getSectionTypeKeys(): IterableIterator<string> {
  return ALL_SECTION_TYPES.keys();
}
